import type { MouseEvent } from "react";
import { Link, useLocation } from "react-router-dom";
import { LOGO_IMG, OFFICE_IMG } from "@/mocks/lawfirm";

export default function Footer() {
  const location = useLocation();

  const handleAnchor = (
    e: MouseEvent<HTMLAnchorElement>,
    to: string
  ) => {
    if (!to.startsWith("/#")) return;
    e.preventDefault();
    const hash = to.split("#")[1];
    if (location.pathname !== "/") {
      window.REACT_APP_NAVIGATE("/");
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-primary-950 text-white">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_IMG} alt="법무법인 평율 로고" title="법무법인 평율" className="h-11 w-auto object-contain brightness-0 invert" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/70">
            광주부장판사·검사출신 김평호 대표변호사.
            <br />
            25년 광주지방법원 부장판사퇴직, 재판의 흐름을 아는 변호사와 함께하세요.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-accent-500/20 px-4 py-1.5 text-xs font-medium text-accent-200">
            <i className="ri-verified-badge-line text-sm"></i>
            대한변호사협회 등록 형사법전문변호사
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm font-semibold text-white/90 tracking-wide">바로가기</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li><a href="/" onClick={(e) => { e.preventDefault(); window.REACT_APP_NAVIGATE("/"); }} className="hover:text-accent-300 transition-colors">홈</a></li>
            <li><a href="/#about" onClick={(e) => handleAnchor(e, "/#about")} className="hover:text-accent-300 transition-colors">변호사 소개</a></li>
            <li><a href="/#practice" onClick={(e) => handleAnchor(e, "/#practice")} className="hover:text-accent-300 transition-colors">수행사건</a></li>
            <li><a href="/#cases" onClick={(e) => handleAnchor(e, "/#cases")} className="hover:text-accent-300 transition-colors">성공사례</a></li>
            <li><Link to="/criminal" className="hover:text-accent-300 transition-colors">형사사건</Link></li>
            <li><a href="/#center" onClick={(e) => handleAnchor(e, "/#center")} className="hover:text-accent-300 transition-colors">회생파산센터</a></li>
            <li><a href="/#contact" onClick={(e) => handleAnchor(e, "/#contact")} className="hover:text-accent-300 transition-colors">상담 신청</a></li>
          </ul>
        </div>

        <div className="md:col-span-5">
          <h4 className="text-sm font-semibold text-white/90 tracking-wide">오시는 길 · 문의</h4>
          <div className="mt-4 space-y-3 text-sm text-white/70">
            <p className="flex items-start gap-2">
              <i className="ri-map-pin-2-line mt-0.5 text-accent-300"></i>
              <span>광주광역시 (법무법인 평율 2층 / 회생·파산센터 3층)</span>
            </p>
            <p className="flex items-center gap-2">
              <i className="ri-phone-line text-accent-300"></i>
              <span>T. 062-227-9990 (법무법인평율)</span>
            </p>
            <p className="flex items-center gap-2">
              <i className="ri-phone-line text-accent-300"></i>
              <span>T. 062-227-9960 (회생파산센터)</span>
            </p>
            <div className="flex flex-col gap-2 pt-2">
              <a
                href="https://blog.naver.com/lawpy9990"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 text-white/70 hover:text-accent-300 transition-colors"
              >
                <i className="ri-blogger-line text-accent-300"></i>
                회생파산센터 블로그 바로가기
              </a>
              <a
                href="https://blog.naver.com/py9990"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 text-white/70 hover:text-accent-300 transition-colors"
              >
                <i className="ri-blogger-line text-accent-300"></i>
                법무법인 평율 블로그 바로가기
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© 2026 법무법인 평율. All rights reserved.</p>
          <p>대표변호사 김평호 · 광주부장판사 검사출신변호사</p>
        </div>
      </div>
    </footer>
  );
}